import { GridInputs } from "../../../../../components/Functional";
import { Spinner } from "../../../../../components/ui";
import { useEntitiesLazy } from "../../../../../hooks/useEntities";

const Registrar = props => {
  const { formik } = props || {};
  const [fetchEntities, { loading, entities }] = useEntitiesLazy();

  const inputs = {
    className: "grid grid-cols-4 gap-16 mt-5",
    inputs: [
      {
        label: "Registrar",
        name: "registrarId",
        onFocus: () => {
          if (!entities) {
            fetchEntities();
          }
        },
        options:
          entities?.edges?.map(item => ({
            label: item?.name,
            value: item?.id,
          })) || [],
        type: "multi-select",
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      {loading && <Spinner />}
      <GridInputs {...gridInputProps} />
    </div>
  );
};

export default Registrar;
